<template>
<!--    {{currentPage}} / {{pageCount}}-->
<!--    <div style="height: 500px; overflow-y: auto;">-->
<!--    border: 1px solid blue-->
  
  <div><!-- vue2 는 루트 엘리먼트가 하나여야 하므로 감싼다 -->
    <pdf
      ref="pdf_ref"
      class="s-pdf-viewer"
      :source="src"
      @loaded="onLoaded"
      @rendered="onRendered"
      @password-requested="onPasswordRequested"
      @loading-failed="onLoadingFailed"
      @rendering-failed="onRenderingFailed"
    />
    <!-- 뷰어가 PDF 를 못 여는 경우의 안내. 이게 없으면 화면이 그냥 비어서 원인을 알 수 없다. -->
    <div v-if="notice" class="q-pa-md text-center text-grey-8" style="white-space: pre-line">
      {{ notice }}
      <div class="q-mt-sm" v-if="showOpenLink">
        <a :href="src" target="_blank">브라우저에서 직접 열기</a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed, PropType, ref, watch} from "vue";
// https://github.com/hrynko/vue-pdf-embed/tree/v1
import pdf from 'vue-pdf-embed/dist/vue2-pdf-embed' // https://github.com/hrynko/vue-pdf-embed#readme

const pdf_ref = ref()
const notice  = ref('') // 미리보기 실패 사유. 비어있으면 안내를 띄우지 않는다.
// 브라우저 내장 뷰어로 여는 링크. 비밀번호를 알아낸 경우 거기서는 입력해 볼 수 있으므로 그때만 띄운다.
// 파일이 없는 경우엔 눌러도 오류 페이지만 나와서 오히려 방해가 된다.
const showOpenLink = ref(false)
const props = defineProps<{ src ?: string }>()

function onLoaded() {
  console.log(`PDF 파일 로딩 완료 : ${props.src}`)
}

function onRendered() { // 로딩 완루 후 랜더인 완료
  console.log(`PDF 파일 랜더링 완료 : ${props.src}`)
}

/**
 * 비밀번호가 걸린 PDF 처리.
 * vue-pdf-embed 는 pdf.js 의 onPassword 콜백을 password-requested 이벤트로 넘기기만 한다.
 * 이 이벤트를 받지 않으면 pdf.js 는 콜백을 기다리며 영구 대기하고,
 * loaded / loading-failed 둘 다 발생하지 않아 화면이 조용히 빈 채로 남는다.
 *
 * 비밀번호는 제출자가 설정한 것이라 관리자가 알 수 없다.
 * 그래서 입력을 요구하지 않고, 비밀번호가 걸렸다는 사실만 알린다.
 */
function onPasswordRequested() {
  notice.value = '비밀번호가 설정된 PDF 라 미리보기를 표시할 수 없습니다.\n제출자에게 비밀번호가 없는 파일로 재제출을 요청해 주세요.'
  showOpenLink.value = true
}

function onLoadingFailed() {
  console.warn(`PDF 파일 로딩 실패 : ${props.src}`)
  notice.value = 'PDF 파일을 열 수 없습니다.'
}

function onRenderingFailed() {
  console.warn(`PDF 파일 랜더링 실패 : ${props.src}`)
  notice.value = 'PDF 파일을 표시할 수 없습니다.'
}

function render() {
  console.log("랜더")
  pdf_ref.value?.render()
}
defineExpose({ render })
</script>

<style scoped>
.s-pdf-viewer { width: 100% }
</style>